import { Message, toaster } from "rsuite";

export const toastError = (message = '') => {
    if (!message) {
        return;
    }

    toaster.push(
        <Message showIcon type="error">
            {message}
        </Message>,
    );
}